import InstructionsContainer from "./Instructions.styles";

const Instructions = () => (
    <InstructionsContainer>
        <p>
            This tracker aims to extract signal where you feel strongly about
            adding/reducing position size within your sector focus.
        </p>
        <p>
            Please assess individual position weighting considering a) relative
            allocation across your sector and b) relative to opportunities
            elsewhere in the portfolio.
        </p>
        <p>
            For example, you should consider the relative opportunity between
            +30% upside in a name in your sector vs opportunity to buy a +90% FV
            upside opportunity in a different sector. Your loves/hates
            considerations may help with this.
        </p>
        <p>General guidelines:</p>
        <ul>
            <li>Your portfolio weightings should reflect your own views.</li>
            <li>
                Where you do not have a strong view either way, please set as
                the live portfolio weighting.
            </li>
            <li>
                Where your view diverges from current weighting, you are
                encouraged to adjust size by +/- 25bps as a MINIMUM and include
                a brief explanatory note.
            </li>
            <li>
                Challenge your team on weightings that diverge from current
                holding or your own view.
            </li>
        </ul>
    </InstructionsContainer>
);

export default Instructions;
